import {
    Divider,
    TextField,
} from "@material-ui/core";
import styled from "styled-components";

const NonDeviationCommentsHelperText = styled.div`
font-family: Roboto;
font-size: 15px;
padding-top:40px;
padding-bottom:40px;
padding-left:20px;
padding-right:20px;
font-weight: 400;
`

const TextFieldLabel = styled.div`
font-family: Roboto;
font-size: 15px;
font-weight: 500;
`
const TextFieldContainer = styled.div`
  width: 100%;
`;

export const NonDeviationContent = (props) => {
    const { deviationComments, onChangeDeviationComments } = props
    return (
        <>
            <NonDeviationCommentsHelperText>
                Okay. This procedure will continue through the approval process.<br /><br />
                The new procedure will <b>NOT</b> replace the prior version in the completed procedures manual.
            </NonDeviationCommentsHelperText>
            <TextFieldLabel>
                Comments*
            </TextFieldLabel>
            <TextFieldContainer>
                <TextField placeholder="Start typing..." value={deviationComments} onChange={onChangeDeviationComments} multiline fullWidth margin="normal" variant="outlined" />
            </TextFieldContainer>
        </>
    );
}